import { motion } from "framer-motion";
import { PORTFOLIO_MEDIA } from "../config";
import { useLang } from "../LanguageContext";
import { Reveal, Eyebrow } from "./Reveal";

export const Portfolio = () => {
  const { t } = useLang();
  return (
    <section id="portfolio" data-testid="portfolio" className="relative py-24 md:py-32 bg-[#080808]">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="max-w-2xl mb-16">
          <Reveal><Eyebrow testId="portfolio-eyebrow">{t.portfolio.eyebrow}</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display text-4xl md:text-6xl text-white tracking-tight leading-[1.05]">
              {t.portfolio.title1} <span className="text-gold-gradient italic">{t.portfolio.title2}</span>
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
          {t.portfolio.items.map((p, i) => (
            <motion.div
              key={i}
              data-testid={`portfolio-item-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 2) * 0.1 }}
              className={`group relative rounded-2xl overflow-hidden h-[300px] md:h-[420px] ${PORTFOLIO_MEDIA[i].span}`}
            >
              <img
                src={PORTFOLIO_MEDIA[i].img}
                alt={`${p.title} — ${p.cat} by Alexa Financial Multiservices`}
                className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 scale-105 group-hover:scale-100 transition-all duration-700 ease-out"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/30 to-transparent" />
              <div className="absolute inset-0 border border-white/10 group-hover:border-[#d4af37]/40 rounded-2xl transition-colors duration-500" />
              <div className="absolute bottom-0 left-0 p-8">
                <div className="text-[11px] tracking-[0.3em] uppercase text-[#d4af37] mb-2 translate-y-2 group-hover:translate-y-0 transition-transform duration-500">{p.cat}</div>
                <h3 className="font-display text-2xl md:text-3xl text-white">{p.title}</h3>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
